<script>
/**
 * O botão de acrescentar de uma seção do painel: contorno pontilhado, texto
 * apagado, e azul ao passar o mouse.
 *
 * O pontilhado é o que separa "isto acrescenta um item" de "isto é um item":
 * na mesma coluna, o participante e o campo personalizado têm contorno cheio.
 * Antes o hover pintava o botão inteiro de azul sólido, o que fazia dele o
 * elemento mais pesado da seção justamente quando o cursor passava por cima.
 *
 * `pill` é a forma que a referência da #1243 usa quando o botão fica ao lado de
 * outros do mesmo tamanho -- as etiquetas -- e não sozinho numa linha.
 */
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    pill: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <button
    type="button"
    class="flex items-center justify-center gap-1.5 text-xs transition-colors duration-150 border border-dashed text-muted border-line-strong hover:border-brand hover:text-brand-text hover:bg-brand/5"
    :class="
      pill
        ? 'h-6 px-2.5 rounded-full font-medium'
        : 'w-full px-3 py-2 rounded-lg'
    "
    @click="$emit('click')"
  >
    <!-- O `+` é o ícone `add`, e não o caractere de texto que estava aqui.
         A 12px os dois ocupam a mesma caixa, mas o glifo tipográfico desenha
         uma cruz bem menor dentro dela — ao lado do "+ Adicionar" das
         etiquetas, que é um `woot-button size="tiny"` (ícone de 12px), a
         diferença aparecia. Mesmo ícone, mesmo tamanho, mesma folga. -->
    <fluent-icon icon="add" size="12" class="shrink-0" />
    <span>{{ label }}</span>
  </button>
</template>
